export default __webpack_public_path__ + "static/media/foto-destaque-b-descicao.706ef550.png";